module.exports = __webpack_public_path__ + "img/save-print-box-ru.576deab4.png";